import React from 'react';

const TextWithLineBreaks = ({ children }) => (
	<div style={{ whiteSpace: 'pre-wrap' }}>{children}</div>
);
export default TextWithLineBreaks;
